import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Collapse } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { formaToTime, formatFromTime, formatTime, getFlexClasses, getLanguage } from '../../Utils/utils';
import moment from "moment/moment";
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@mui/material/LinearProgress';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import LoadingSpinner from "../LoadingSpinner";
import Select from 'react-select';
import EditModal from "../EditModal/EditModal";
import NotesModal from "../Modals/NotesModal";
import ArchiveModal from "../Modals/ArchiveModal";
import config from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import downImg from "./down-arrow.svg";
import UpImg from "./up-arrow.svg";
import CustomSearch from "../CustomSearch";
import { normalTime, TimetoConvert } from "../../Utils/TimeUtils";


const FlexClasses = (props) => {
  const [data, setData] = useState([])
  const [filterText, setFilterText] = useState('');
  const [newData, setNewData] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5)
  const [pageCount, setPageCount] = useState(2);
  const [itemOffset, setItemOffset] = useState(0);
  const [selectRowsArr, setSelectRowsArr] = useState([]);
  const [flexClasses, setFlexClasses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [flexData, setFlexData] = useState([]);
  const [lang, setLang] = useState([]);
  const [langval, setLangVal] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isClearable, setIsClearable] = useState(true);
  const [notesShow, setNotesShow] = useState(false);
  const [archiveShow, setArchiveShow] = useState(false);
  const [noteuserId, setNoteUserId] = useState('');
  const [userNote, setUserNote] = useState('');
  const [noteNew, setNoteNew] = useState('');
  const [reloadData, setReloadData] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [archiveMultiple, setArchieveMultiple] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);

  const handleFilterChange = (e) => { setFilterText(e.target.value); };

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const getAllFlexClasses = async () => {
    setIsLoading(true)
    var res = await getFlexClasses()
    if (res.status == 200) {
      setFlexData(res.data)
      setFlexClasses(res.data)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAllFlexClasses()
    setPageCount(data.length / maxPageLimit)
  }, [])
  const flexColumns = [
    {
      id: 1,
      name: "Student Id",
      width: '110px',
      sortable: true,
      selector: (row) =>
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px'
          }}>
          {row.LD_SID}
        </div>
    },
    {
      id: 2,
      name: "Course No.",
      sortable: true,
      width: "120px",
      selector: (row) => row.COURSE_NUMBER,
      cell: (row) =>
        <div className='cell-link'
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px'
          }}
          onClick={() => {
            setShowModal(true)
            setSelectedRow(row)
          }}>{row.COURSE_NUMBER}
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      id: 3,
      name: "Rank",
      selector: (row) => row.RANK,
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper'
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: '12px'
              }}
            >{row.RANK}</div>
          </div>
        </>,
      width: "80px",
      sortable: true,
    },
    {
      id: 4,
      name: "First Name",
      sortable: true,
      width: '110px',
      selector: (row) => row.FIRSTNAME,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.FIRSTNAME}
        </div>
      ),
    },
    {
      id: 5,
      name: "Last Name",
      selector: (row) => row.LASTNAME,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LASTNAME}
        </div>
      ),
      width: '110px',
      sortable: true,
    },
    {
      id: 6,
      name: "Language",
      sortable: true,
      selector: (row) => row.LANGUAGE,
      width: '110px',
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LANGUAGE.includes('/') ? row.LANGUAGE.split('-')[0].trim() : row.LANGUAGE}
        </div>
      ),
    },
    {
      id: 7,
      name: "Home Email",
      sortable: true,
      selector: (row) => row.HOME_EMAIL,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.HOME_EMAIL}
        </div>
      ),
      width: "250px"
    },
    {
      id: 8,
      name: "Phone Number",
      width: "120px",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.PHONE}
        </div>
      ),
    },
    {
      id: 9,
      name: "Timezone",
      sortable: true,
      selector: row => row.TIMEZONE,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.TIMEZONE.includes('-') ? row.TIMEZONE.split('/')[0].trim() : row.TIMEZONE}
        </div>
      ),
      width: "150px"
    },
    {
      id: 10,
      name: "Uploaded On",
      selector: (row) => row.created_on,
      cell: (row) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px'
          }}>
          {moment(row.created_on).format('MM/DD/YYYY hh:mm a')}
        </div>
      ),
      sortable: true,
      width: "120px"
    },
    {
      id: 11,
      name: "Start Date",
      sortable: true,
      selector: (row) => row.AVAILABLE_START_DATE,
      cell: (row) => <div className='cell-link'
        style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{moment(row.AVAILABLE_START_DATE).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 12,
      name: "End Date",
      sortable: true,
      selector: (row) => row.AVAILABLE_END_DATE,
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{moment(row.AVAILABLE_END_DATE).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 13,
      name: "MON",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.MON_FROM ? <>
            {TimetoConvert(row?.MON_FROM, row?.MON_TO, row?.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    {
      id: 14,
      name: "TUE",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.TUE_FROM ? <>
            {TimetoConvert(row.TUE_FROM, row.TUE_TO, row.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    {
      id: 15,
      name: "WED",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.WED_FROM ? <>
            {TimetoConvert(row.WED_FROM, row.WED_TO, row.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    {
      id: 16,
      name: "THUR",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.THUR_FROM ? <>
            {TimetoConvert(row.THUR_FROM, row.THUR_TO, row.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    {
      id: 17,
      name: "FRI",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.FRI_FROM ? <>
            {TimetoConvert(row.FRI_FROM, row.FRI_TO, row.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    {
      id: 18,
      name: "SAT",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.SAT_FROM ? <>
            {TimetoConvert(row.SAT_FROM, row.SAT_TO, row.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    {
      id: 19,
      name: "SUN",
      cell: (row) => <div className='cell-link' style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>
        <div className="display-time">
          {row.SUN_FROM ? <>
            {TimetoConvert(row.SUN_FROM, row.SUN_TO, row.TIMEZONE)}
          </> : ''}
        </div>
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "70px"
    },
    // {
    //   id: 20,
    //   name: "Notes",
    //   width:'120px',
    //   selector: (row) => 
    //     <div style={{
    //       margin: '5px',
    //       whiteSpace: 'normal', 
    //       wordBreak: 'break-word', 
    //       overflow: 'hidden', 
    //       textOverflow: 'ellipsis',
    //       fontSize:'12px' 
    //     }}>
    //       {row.notes}
    //     </div>
    // },
    {
      id: 21,
      name: "Action",
      cell: (row) => <div className='cell-link'>
        <>
          <i className="text-warning far fa-sticky-note mr-2" title="Notes"
            onClick={() => {
              setNotesShow(true)
              setNoteUserId(row?.LD_SID)
              setUserNote(row?.notes)
            }}>
          </i>
          <i className="text-success fas fa-archive ml-3" title="Archive"
            onClick={() => {
              setArchiveShow(true)
              setNoteUserId(row?.LD_SID)
            }}></i></></div>,
      // selector: (row) => <><i class="far fa-sticky-note"></i> <i class="fas fa-archive"></i></>,
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };

  const onSubmit = async () => {
    setIsLoading(true)
    var temp = []
    // console.log(selectRowsArr)
    selectRowsArr.map((e) => {
      // console.log(e.LANGUAGE)
      temp.push({
        "id": e.id,
        "instructorId": e.instructor_id == null ? null : e.instructor_id,
        "trainerId": e.trainer_id == null ? null : e.trainer_id,
        "statusId": e.status_id,
        "classPeriod": 10, //static
        "ldSID": e.LD_SID,
        "LD_SID": e.LD_SID,
        "rank": e.RANK,
        "firstName": e.FIRSTNAME,
        "lastName": e.LASTNAME,
        "homeEmail": e.HOME_EMAIL,
        "workEmail": e.WORK_EMAIL,
        "phoneNumber": e.PHONE,
        "courseNumber": e.COURSE_NUMBER,
        "timeZone": e.TIMEZONE,
        "language": e.LANGUAGE,
        "souStatus": "",
        "selectedSchedule": e.selected_schedule == null ? null : e.selected_schedule,
        "serializedCourseNumber": e.serialized_course_number == null ? null : e.serialized_course_number,
        "courseType": e.COURSETYPE == null ? null : e.COURSETYPE,
        "newStartDate": null,
        "newEndDate": null,
        "instructorName": e.instructor_name == null ? null : e.instructor_name,
        "archiveReason": null,
        "notes": e.notes == null ? null : e.notes,
        "studentType": "GROUP", //stattic
        "availability": "<ul><li>TUE+-+17:00+-+20:00<br></li><li>THUR+-+17:00+-+20:00<br></li><li>WED+-+17:00+-+20:00<br></li><li>FRI+-+17:00+-+20:00<br></li><li>MON+-+17:00+-+20:00<br></li></ul>",
        "spaceAInd": "",
        "anchorCourse": e.ANCHOR_COURSE,
        "moduleLevel": "FR22-15M2",
        "canBeAddedTo": [],
        "matchesWithExisting": [],
        "potentialCanBeAddedTo": [],
        "potentialMatchesWithExisting": [],
        "availableStartDateMs": moment.utc(e.AVAILABLE_START_DATE, "DD-MMM-YYYY").valueOf(),
        "availableEndDateMs": new Date(e.AVAILABLE_END_DATE).getTime(),
        "uploadedOn": new Date(e.created_on).getTime(),
        "archivedOn": null,
        "souSentOn": e.sou_sent_on == null ? null : e.sou_sent_on,
        "exportedOn": null,
        "souSignedOn": e.sou_signed_on == null ? null : e.sou_signed_on,
        "trainingOn": null,
        "schedule": {
          "MON": {
            "timezone": e.TIMEZONE,
            "from": e.MON_FROM,
            "to": e.MON_TO,
            "orgZonedDay": "MON"
          },
          "TUE": {
            "timezone": e.TIMEZONE,
            "from": e.TUE_FROM,
            "to": e.TUE_TO,
            "orgZonedDay": "TUE"
          },
          "WED": {
            "timezone": e.TIMEZONE,
            "from": e.WED_FROM,
            "to": e.WED_TO,
            "orgZonedDay": "WED"
          },
          "THUR": {
            "timezone": e.TIMEZONE,
            "from": e.THUR_FROM,
            "to": e.THUR_TO,
            "orgZonedDay": "THUR"
          },
          "FRI": {
            "timezone": e.TIMEZONE,
            "from": e.FRI_FROM,
            "to": e.FRI_TO,
            "orgZonedDay": "FRI"
          },
          "SAT": {
            "timezone": e.TIMEZONE,
            "from": e.SAT_FROM,
            "to": e.SAT_TO,
            "orgZonedDay": "SAT"
          },
          "SUN": {
            "timezone": e.TIMEZONE,
            "from": e.SUN_FROM,
            "to": e.SUN_TO,
            "orgZonedDay": "SUN"
          }
        },
        "lang": {
          "id": e.language.id, //static
          "code": e.LANGUAGE_ID,
          "language": e.LANGUAGE
        },
        "isSelected": true,
        "expandAvailability": false,
        "trainingAccepted": null,
        "studentAttendedTraining": null,
        "webexCreated": null,
        "completed": null
      })
    })
    var token = localStorage.getItem('access_token');
    let path = config.siteUrl;

    await axios.post(path + '/classes/process-raw-data-new', {
      data: temp,
      type: "Flex"
    }, {
      headers: { 'content-Type': 'application/json', Authorization: `${token}` },
    })
      .then((response) => {
        if (response.data.status == 200) {
          props.setIsSubmitFlex(true)
          props.setIsFlex(true)
          setIsOpen(false)
          setSelectRowsArr([])
          setToggleCleared((prev) => !prev)

          const temp_arr = response.data.data.map((a) => {
            const match_time = [];
            Object.keys(a.matchedTimings).map((b) => {
              match_time.push({
                isSelected: false,
                isConflictWithInstructor: false,
                classDay: b,
                classTime: `${a?.matchedTimings[b]?.from}-${a?.matchedTimings[b]?.to}EST`,
              });
            });
            a.newMatchedTimings = match_time;
            return a;
          });
          props.setSelectArray(temp_arr);
        }
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      });

  }

  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

  // The Material UI way...
  const LinearIndeterminate = () => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );
  };

  const filterItem = (curcat) => {
    const newItem = flexClasses.filter((newVal) => {
      return newVal.LANGUAGE_ID === curcat;
    });
    setFlexClasses(newItem)
  }

  const getLangs = async () => {
    var temp = []
    var res = await getLanguage()

    if (res !== null) {
      const tableLanguages = [...new Set(flexData.map(item => item.language.name))]

      res.filter(e => tableLanguages.includes(e.name)).map((e) => {
        temp.push({
          value: e.LANGUAGE_ID, label: e.name
        })
      })

      setLang(temp)
    }
  }

  useEffect(() => {
    if (langval == null || langval == "") {
      setFlexClasses(flexData)
    } else {
      filterItem(langval.value)
    }
    setIsLoading(false)
  }, [langval])

  useEffect(() => {
    getLangs()
  }, [flexData])

  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    },
  ];

  useEffect(() => {
    getAllFlexClasses()
  }, [noteNew])

  useEffect(() => {
    getAllFlexClasses()

  }, [reloadData])

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="mt-4">
        <div className="row" style={{ borderBottom: '1px solid #ccc' }}>
          <div className="col-lg-6" style={{ display: 'flex', alignItems: 'center' }}>
            <div className='heading-text' onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
              Flex Student Data
            </div>
            <div>
              <img
                src={isOpen == true ? UpImg : downImg}
                alt="Description of the image"
                style={{ width: '26px', height: '26px', cursor: 'pointer', marginLeft: '5px' }}
                onClick={toggleCollapse}
              />
            </div>
          </div>
          <div class="col-lg-3">
            <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
          </div>
          <div className="col-lg-3">
            <div>
              <Select
                name="languages"
                value={langval}
                options={lang}
                className="basic-multi-select"
                classNamePrefix="select"
                isClearable={isClearable}
                onChange={(e) => {
                  setIsLoading(true)
                  setLangVal(e)
                  if (e == null) {
                    setFlexClasses(flexData)
                    setLangVal('')
                  } else {
                    setFlexClasses(flexData)
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                <Collapse in={isOpen}>
                  <div>
                    <div>
                      {flexClasses.length > 0 ? <>
                        <DataTableExtensions
                          columns={flexColumns}
                          // data={flexClasses.filter((item) => Object.values(item).some((value) => String(value).toLowerCase().includes(filterText.toLowerCase())))}
                          data={flexClasses.filter((item) =>
                            [item.COURSE_NUMBER, item.FIRSTNAME, item.LASTNAME].some((value) => {
                              if (!value) return false;

                              const strValue = String(value).toLowerCase();

                              // Special handling for COURSE_NUMBER pattern extraction
                              if (item.COURSE_NUMBER) {
                                const match = String(item.COURSE_NUMBER).match(/-(\d{2}).*(\w{2})$/);
                                const extracted = match ? match[1] + match[2] : "";

                                // Strict match for COURSE_NUMBER extracted pattern
                                if (extracted.toLowerCase() === filterText.toLowerCase().trim()) {
                                  return true;
                                }
                              }

                              // Case insensitive contains search for all three fields
                              return strValue.includes(filterText.toLowerCase().trim());
                            })
                          )}
                          print={false}
                          export={false}
                          filter={false}
                        >
                          <DataTable
                            pagination
                            paginationComponentOptions={paginationComponentOptions}
                            selectableRows
                            clearSelectedRows={toggleCleared}
                            conditionalRowStyles={conditionalRowStyles}
                            onSelectedRowsChange={({ selectedRows }) => setSelectRowsArr(selectedRows)}
                            persistTableHead
                            progressPending={isLoading}
                            progressComponent={<LinearIndeterminate />}
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            highlightOnHover
                            className="custom-table-border"
                            customStyles={{
                              headCells: {
                                style: {
                                  backgroundColor: '#8A8A8A;',
                                  color: '#ffffff'
                                }
                              }
                            }}
                          />
                        </DataTableExtensions>
                      </> :
                        <div className="no-record">
                          There are no records to display.
                        </div>
                      }
                    </div>
                    <div className="bottom-btn-conatiner">
                      <div className="d-flex gap-5 me-5">
                        {flexClasses.length > 0 ? <>
                          <div className="btn-box">
                            <div
                              className="main-btn"
                              onClick={() => {
                                if (selectRowsArr.length > 0) {
                                  setArchieveMultiple(true);
                                } else {
                                  toast.error("Please select data");
                                }
                              }}
                            >
                              Archive Selected
                            </div>
                          </div>


                          <div className="btn-box">
                            <div
                              className="main-btn-fill"
                              onClick={() => {
                                if (selectRowsArr.length > 0) {
                                  onSubmit();
                                } else {
                                  toast.error("Please select data");
                                }
                              }}
                            >
                              Start Processing
                            </div>
                          </div>


                        </> : ''}
                      </div>
                    </div>

                  </div>
                </Collapse>
              </div>
            </div>
          </div>
          {showModal == true ?
            <EditModal
              showModal={showModal}
              setShowModal={setShowModal}
              selectedRow={selectedRow}
            />
            : null}
          {notesShow == true ?
            <NotesModal
              notesShow={notesShow}
              setNotesShow={setNotesShow}
              noteUserId={noteuserId}
              userNote={userNote}
              setNoteNew={setNoteNew}
            />
            : null}
          {archiveShow == true ?
            <ArchiveModal
              archiveShow={archiveShow}
              setArchiveShow={setArchiveShow}
              noteUserId={noteuserId}
              setReloadData={setReloadData}
            />
            : null}
          {archiveMultiple == true ?
            <ArchiveModal
              archiveMultiple={archiveMultiple}
              setArchieveMultiple={setArchieveMultiple}
              selectedRows={selectRowsArr}
              setSelectedRows={setSelectRowsArr}
              setReloadData={setReloadData}
            />
            : null}
        </div >
      </div>
    </>
  )
}
export default FlexClasses